import React, { createContext, useState, useContext, useEffect } from 'react';
import { getCurrentUser } from '../services/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(() => getCurrentUser());

  const refreshUser = () => {
    setCurrentUser(getCurrentUser());
  };

  useEffect(() => {
    const handleForcedLogout = () => setCurrentUser(null);
    window.addEventListener('auth:logout', handleForcedLogout);
    return () => window.removeEventListener('auth:logout', handleForcedLogout);
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
